import React, { useEffect, useState } from "react";
import styles from "./standard-reward-row.module.css";
import { v4 } from "uuid";
import getImageFileName from "../../functions/getImageFileName";
import { replaceColorTag } from "../../functions/stringFunctions";
import { JOURNEY_REWARD_TYPE, JOURNEY_STATUS_KEY_TYPE, LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";

export default function StandardRewardRow({ lang, reward, reward_flag, difficulty }) {
    const [selected, setSelected] = useState();
    const [isActive, setIsActive] = useState(false);

    const [potentials, setPotentioals] = useState(null);
    const [statPotentials, setStatPotentials] = useState(null);
    const [buffs, setBuffs] = useState(null);
    const [journeyItems, setJourneyItems] = useState(null);

    useEffect(() => {
        loadData("potentials.json").then(setPotentioals);
        loadData("stat_potentials.json").then(setStatPotentials);
        loadData("journey_buffs.json").then(setBuffs);
        loadData("journey_items.json").then(setJourneyItems);
    }, []);

    if (!potentials || !statPotentials || !buffs || !journeyItems) return;

    const toggleItem = (isActive, obj) => {
        if (isActive) {
            if (selected && obj && (selected.type !== obj.type || selected.reward_id !== obj.reward_id)) {
                // change selected
                setSelected(obj);
            } else {
                // to false
                setIsActive(false);
                setSelected(undefined);
            }
        } else {
            // to true
            setIsActive(true);
            setSelected(obj);
        }
    };

    const getSignMarkedValue = (value) => {
        if (value > 0) return `+${value}`;

        return value;
    };

    const innerHTML = reward.map((each, index) => {
        const isPositive = each.min > 0 ? true : false;

        if (each.type === "RT_STAT") {
            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_STATUS_KEY_TYPE[each.reward_stat][lang]}
                    &nbsp;
                    <span className={styles[isPositive ? "plus" : "minus"]}>
                        {each.min === each.max
                            ? getSignMarkedValue(each.min)
                            : `${getSignMarkedValue(each.min)}~${getSignMarkedValue(each.max)}`}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_SE_POTEN") {
            const potential = potentials.find((e) => e.id === each.reward_id);

            return (
                <div className={`${styles["desc-row"]}`} key={v4()}>
                    {/* {index === 0 && `${each.type} `}
                    &nbsp; */}
                    <div className={`${styles["desc-row-info"]} ${styles["special"]}`} onClick={() => toggleItem(isActive, each)}>
                        <div className={styles["potential-icon"]}>
                            {potential.unitId === 0 && potential.class === "" && (
                                <img src={`${process.env.PUBLIC_URL}/images/icon/potential/bg_yellow.webp`} />
                            )}
                            {(potential.unitId !== 0 || potential.class !== "") && (
                                <img src={`${process.env.PUBLIC_URL}/images/icon/potential/bg_blue.webp`} />
                            )}
                            <img
                                src={`${process.env.PUBLIC_URL}/images/icon/potential/${getImageFileName(potential.name[LOCALES.KO])}.webp`}
                                className={styles["potential-logo"]}
                            />
                        </div>
                        &nbsp;
                        {potential.name[lang]}
                        &nbsp;
                        {typeof each.min === "number" && (
                            <span className={styles[isPositive ? "plus" : "minus"]}>
                                {each.min * 10}% {lang === LOCALES.KO ? "할인" : "Discount"}
                            </span>
                        )}
                    </div>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_JOURNEY_BUFF") {
            const buff = buffs.find((e) => e.id === each.reward_id);
            return (
                <div className={`${styles["desc-row"]}`} key={v4()}>
                    {index === 0 && `${JOURNEY_REWARD_TYPE[each.type][lang]} `}
                    &nbsp;
                    <div className={`${styles["desc-row-info"]} ${styles["special"]}`} onClick={() => toggleItem(isActive, each)}>
                        <img src={`${process.env.PUBLIC_URL}/images/icon/journey_buff/${getImageFileName(buff.name[LOCALES.KO])}.webp`} />
                        &nbsp;{buff.name[lang]}
                        &nbsp;
                        {each.min && (
                            <span className={styles[isPositive ? "plus" : "minus"]}>
                                {each.min === each.max
                                    ? `${getSignMarkedValue(each.min)}${lang === LOCALES.KO ? "턴" : "Turn"}`
                                    : `${getSignMarkedValue(each.min)}~${getSignMarkedValue(each.max)}`}
                            </span>
                        )}
                    </div>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_JOURNEY_ITEM") {
            const item = journeyItems.find((e) => e.id === each.reward_id);
            return (
                <div className={`${styles["desc-row"]}`} key={v4()}>
                    {/* {index === 0 && `${each.type}`}
                    &nbsp; */}
                    <div className={`${styles["desc-row-info"]} ${styles["special"]}`} onClick={() => toggleItem(isActive, each)}>
                        <img src={`${process.env.PUBLIC_URL}/images/item/${getImageFileName(item.name[LOCALES.KO])}.webp`} />
                        &nbsp;{item.name[lang]}
                    </div>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_STAT_POTEN") {
            const potential = statPotentials.find((e) => e.id === each.reward_id);
            return (
                <div className={`${styles["desc-row"]}`} onClick={() => toggleItem(isActive, each)} key={v4()}>
                    {index === 0 && `${JOURNEY_REWARD_TYPE[each.type][lang]}`}
                    &nbsp;
                    <div className={styles["potential-icon"]}>
                        <img src={`${process.env.PUBLIC_URL}/images/icon/potential/stat_potential_bg.webp`} />
                        <img
                            src={`${process.env.PUBLIC_URL}/images/icon/potential/${getImageFileName(potential.name[LOCALES.KO])}.webp`}
                            className={styles["stat-potential-logo"]}
                        />
                    </div>
                    &nbsp;{potential.name[lang]} - &nbsp;{JOURNEY_STATUS_KEY_TYPE[potential.stat_type][lang]}&nbsp;{potential.stat_value}
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type.includes("REMOVE")) {
            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_REWARD_TYPE[each.type][lang]}
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else if (each.type === "RT_POTEN_POINT") {
            let min = each.min;
            if (difficulty && difficulty[LOCALES.KO] === "노말") min *= 1.5;
            if (difficulty && difficulty[LOCALES.KO] === "하드") min *= 2.5;

            let max = each.max;
            if (difficulty && difficulty[LOCALES.KO] === "노말") max *= 1.5;
            if (difficulty && difficulty[LOCALES.KO] === "하드") max *= 2.5;

            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_REWARD_TYPE[each.type][lang]}
                    &nbsp;
                    <span className={styles[isPositive ? "plus" : "minus"]}>
                        {min === max ? getSignMarkedValue(min) : `${getSignMarkedValue(min)}~${getSignMarkedValue(max)}`}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        } else {
            return (
                <div className={styles["desc-row"]} key={v4()}>
                    {JOURNEY_REWARD_TYPE[each.type][lang]}
                    &nbsp;
                    <span className={styles[isPositive ? "plus" : "minus"]}>
                        {each.min === each.max
                            ? getSignMarkedValue(each.min)
                            : `${getSignMarkedValue(each.min)}~${getSignMarkedValue(each.max)}`}
                    </span>
                    {index < reward.length - 1 && <span className={styles["plain"]}>&nbsp;or&nbsp;</span>}
                </div>
            );
        }
    });

    return (
        <div className={`${styles["reward"]} ${styles[reward_flag]}`} style={{ maxHeight: `${isActive ? 100 : 100}px` }}>
            <div className={styles["desc"]}>{innerHTML}</div>
            {selected && selected.type === "RT_SE_POTEN" && (
                <div
                    className={styles["value-desc"]}
                    dangerouslySetInnerHTML={{ __html: replaceColorTag(potentials.find((e) => e.id === selected.reward_id).desc[lang]) }}
                ></div>
            )}
            {selected && selected.type === "RT_JOURNEY_BUFF" && (
                <div
                    className={styles["value-desc"]}
                    dangerouslySetInnerHTML={{ __html: replaceColorTag(buffs.find((e) => e.id === selected.reward_id).desc[lang]) }}
                ></div>
            )}
            {selected && selected.type === "RT_JOURNEY_ITEM" && (
                <div
                    className={styles["value-desc"]}
                    dangerouslySetInnerHTML={{
                        __html: replaceColorTag(journeyItems.find((e) => e.id === selected.reward_id).charm_info.se_list[0][lang]),
                    }}
                ></div>
            )}
        </div>
    );
}
